module.exports = __webpack_public_path__ + "media/src/images/bg/bg5-5905abfecd4c972b084a7ad9d8f81c9a.jpg";